import styled from 'styled-components'
import { Button } from 'components/Button'

export const TableHeaderContainer = styled.div`
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h3 {
    font-size: 1.3rem;
    font-weight: 600;
  }

  label {
    font-weight: bold;
    margin-right: 0.25rem;
  }
`

export const PrintButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.info.main};
`
